"use client";

import { CoreFeaturesSection } from "@/components/sections/core-features";
import { coreFeatures } from "@/lib/data/services-search-dominance-seo";

export function CoreFeatures() {
  return (
    <CoreFeaturesSection
      eyebrow={coreFeatures.eyebrow}
      title={coreFeatures.title}
      features={coreFeatures.features}
      accent={coreFeatures.accent}
      featureAccents={coreFeatures.featureAccents}
    />
  );
}
